var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page rsvp"},[_c('top-bar'),_c('div',{style:({ 
    padding: '40px',
    color: _vm.colors.paleYellow,
    backgroundColor: _vm.colors.indigoDark
    })},[_c('rsvp-form',{attrs:{"fg":_vm.colors.tanDark,"bg":_vm.colors.tan}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }